export default __webpack_public_path__ + "static/media/vip-1.d2ad9d30.webp";